import { Type } from 'lucide-react';
import { type ReactElement, useId } from 'react';
import { RailIconButton } from '@/shared/ui';

interface AddTextButtonProps {
  readonly disabledReason?: string | null;
  readonly onAdd: () => void;
}

/** 스테이지 도구 칸의 [텍스트] — 텍스트 추가. 허용 폰트·잉크가 없는 상품은 사유와 함께 비활성(U5). */
export const AddTextButton = ({
  disabledReason = null,
  onAdd,
}: AddTextButtonProps): ReactElement => {
  const reasonId = useId();
  return (
    <div className="relative flex min-w-0 flex-1 lg:flex-none">
      <RailIconButton
        icon={Type}
        label="텍스트"
        accessibleName="텍스트 추가"
        title={disabledReason ?? '텍스트 추가'}
        describedBy={disabledReason === null ? undefined : reasonId}
        disabled={disabledReason !== null}
        onClick={onAdd}
      />
      {disabledReason !== null && (
        <span id={reasonId} className="sr-only">
          {disabledReason}
        </span>
      )}
    </div>
  );
};
